const loadedScripts = {} as Record<string, boolean>

const init = (url: string, id: string): Promise<void> => {
  return new Promise((resolve, reject): void => {
    let lib = window.document.getElementById(id) as HTMLScriptElement
    if (lib) {
      // The lib is already initialized and the script tag is appended to DOM.
      // Will not init again and try call resolve accordingly the state of previous initialization.
      if (loadedScripts[id] === true) {
        // The script is loaded. Safe to resolve immediately.
        return resolve()
      } else {
        // The script is loading. Append resolve() to previous onload function
        // then they will excute together when the script get loaded.
        const prevOnload = lib.onload
        lib.onload = (event) => {
          if (typeof prevOnload === 'function') {
            prevOnload.call(lib, event)
          }
          resolve()
        }
      }
    } else {
      lib = window.document.createElement('script')
      lib.async = true
      lib.onload = () => {
        loadedScripts[id] = true
        resolve()
      }
      lib.onerror = (event) => {
        // Remove the failed tag so a later init() retries the load instead of
        // finding a dead #id in the DOM and waiting on an onload that will
        // never fire (the promise would hang forever, silently).
        lib.remove()
        reject(event)
      }
      lib.id = id
      lib.src = url
      window.document.head.appendChild(lib)
    }
  })
}

export default init
